export const environment = {
    "name": "dev",
    "properties": {
        "production": false,
        "ssdURL": "https://njm-poc.winlen.us/api/",
        "tenantName": "neutrinos-report-fetch-ui",
        "appName": "neutrinos-report-fetch-ui",
        "namespace": "com.neutrinos-report-fetch-ui.neutrinos-report-fetch-ui",
        "useDefaultExceptionUI": true,
        "isIDSEnabled": "false",
        "webAppMountpoint": "web",
        "NGFORAGE_MOBILE_DRIVER": "INDEXED_DB"
    }
}